/**
 * Container width (px) at and above which the progress chart draws at its
 * true size — text, points and spacing stop growing past this.
 */
export const CHART_REFERENCE_WIDTH = 1000

/** Smallest the chart shrinks to on a narrow screen, so text stays readable. */
export const CHART_MIN_SCALE = 0.75

/**
 * How much the chart is scaled for a container of the given width: 1 on wide
 * screens, shrinking in proportion below the reference width, never under the
 * floor.
 */
export const getChartScale = (containerWidth: number): number =>
  Math.min(1, Math.max(CHART_MIN_SCALE, containerWidth / CHART_REFERENCE_WIDTH))
